export class DealModel {
    id: number;
    dealKey: string;
    isTrial: boolean;
    companyName: string;
    authorizedID: string;
    subscriptionNumber: number;
    fullAddress: string;
    phoneNumber: string;
    zipNumber: string;
    fax: string;
    contactName: string;
    contactIdentityNumber: string;
    mobileNumber: string;
    email: string;
    contactRole: string;
    termOfUse: string;
    signedDate: Date;
    signature: string;
    companySignature: ByteString;
    companySignatureType: string;
    statusID: number;
    trialDurationDays: number;
    trialDurationMinutes: number;
    packageApproved: boolean;
    creditCardNumber: string;
    creditCardName: string;
    creditCardExpiryDate: string;
    creditCardCVV: number;
    creditCardToken: string;
    bankNumber: number;
    bankAccountName: string;
    bankBranchNumber: number;
    bankAccountNumber: number;
  termsApproved: boolean;
  saturdayService: boolean;
    paymentType: number;
    pageNumber: number;
    createDate: Date;
    lastUpdate: Date;
    isDeleted: boolean;
    creatorID: number;
    updatorID: number;
    bankIdentityNumber: string;
    creditCardIdentityNumber: string;
    isSignedFromMobile: boolean;
     serviceTypeID: number;
}




// WEBPACK FOOTER //
// ./src/app/_models/deal.model.ts